var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "printerList" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("CloudPrinter"), name: "cloud" } },
            [
              _vm.printer_list.length > 0
                ? _c(
                    "div",
                    { staticClass: "container" },
                    _vm._l(_vm.printer_list, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "cardItem" },
                        [_c("printerItem", { attrs: { printerInfo: item } })],
                        1
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "no-printer-box" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/imgs/noPrinterLists.png"),
                        alt: "",
                      },
                    }),
                    _c("div", { staticClass: "no-printer-text" }, [
                      _vm._v(_vm._s(_vm.$t("no_printer_connected"))),
                    ]),
                  ]),
            ]
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("LANPrinter"), name: "lan" } },
            [
              _vm.$store.getters.GET_LAN_PRINTER_LIST.length > 0
                ? _c(
                    "div",
                    { staticClass: "container" },
                    _vm._l(
                      _vm.$store.getters.GET_LAN_PRINTER_LIST,
                      function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "cardItem" },
                          [
                            _c("LanPrinterItem", {
                              attrs: { printerInfo: item },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  )
                : _c("div", { staticClass: "no-printer-box" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/imgs/noPrinterLists.png"),
                        alt: "",
                      },
                    }),
                    _c("div", { staticClass: "no-printer-text" }, [
                      _vm._v(_vm._s(_vm.$t("no_printer_connected"))),
                    ]),
                  ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }